export function getNormalDate(date) {
    let t = date.split(/[- :T]/)
    let str = `${t[2]}.${t[1]}.${t[0]} ${t[3]}:${t[4]}`
    return str
}


